"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionKey = exports.ActionType = exports.CommunicationDataRecipient = void 0;
var CommunicationDataRecipient;
(function (CommunicationDataRecipient) {
    CommunicationDataRecipient[CommunicationDataRecipient["FirstWaypointContacts"] = 3] = "FirstWaypointContacts";
    CommunicationDataRecipient[CommunicationDataRecipient["LastWaypointContacts"] = 4] = "LastWaypointContacts";
})(CommunicationDataRecipient || (exports.CommunicationDataRecipient = CommunicationDataRecipient = {}));
var ActionType;
(function (ActionType) {
    ActionType[ActionType["ALERT"] = 0] = "ALERT";
    ActionType[ActionType["INTERNAL_SMS"] = 1] = "INTERNAL_SMS";
    ActionType[ActionType["EMAIL"] = 2] = "EMAIL";
    ActionType[ActionType["WEBHOOK"] = 3] = "WEBHOOK";
    ActionType[ActionType["ENTITY_UPDATE"] = 4] = "ENTITY_UPDATE";
    ActionType[ActionType["RELEASE"] = 5] = "RELEASE";
    ActionType[ActionType["MARK_NOT_READY"] = 6] = "MARK_NOT_READY";
    ActionType[ActionType["FINISH_TASK"] = 7] = "FINISH_TASK";
    ActionType[ActionType["SHARE_WITH_CUSTOMER"] = 8] = "SHARE_WITH_CUSTOMER";
    ActionType[ActionType["AUTO_UNASSIGN"] = 9] = "AUTO_UNASSIGN";
    ActionType[ActionType["RESCHEDULE_TASKS"] = 10] = "RESCHEDULE_TASKS";
    ActionType[ActionType["SHARED_LOCATION"] = 11] = "SHARED_LOCATION";
    ActionType[ActionType["CONVERT_LINKED_TO_MM"] = 12] = "CONVERT_LINKED_TO_MM";
    ActionType[ActionType["CONVERT_MM_TO_LINKED"] = 13] = "CONVERT_MM_TO_LINKED";
    ActionType[ActionType["OPTIMIZATION"] = 14] = "OPTIMIZATION";
    ActionType[ActionType["CANCEL_TASK"] = 15] = "CANCEL_TASK";
    ActionType[ActionType["TOTAL_WEIGHT_NULLIFY"] = 16] = "TOTAL_WEIGHT_NULLIFY";
    ActionType[ActionType["TOTAL_HANDLING_UNITS_NULLIFY_ALL"] = 17] = "TOTAL_HANDLING_UNITS_NULLIFY_ALL";
    ActionType[ActionType["LEAN_COPY"] = 18] = "LEAN_COPY";
    ActionType[ActionType["CALCULATE_AVAILABILITY_STATE"] = 19] = "CALCULATE_AVAILABILITY_STATE";
    ActionType[ActionType["CALCULATE_AVAILABILITY_STATE_GENERIC"] = 20] = "CALCULATE_AVAILABILITY_STATE_GENERIC";
    ActionType[ActionType["ASSIGN_TEAM_BY_PDW"] = 21] = "ASSIGN_TEAM_BY_PDW";
    ActionType[ActionType["NARROW_ACTIONABLE_WP_TIME_WINDOW"] = 22] = "NARROW_ACTIONABLE_WP_TIME_WINDOW";
    ActionType[ActionType["EMAIL_SHARED_LOCATION"] = 23] = "EMAIL_SHARED_LOCATION";
    ActionType[ActionType["TASK_WEBHOOK"] = 24] = "TASK_WEBHOOK";
    ActionType[ActionType["TASKS_WEBHOOK"] = 25] = "TASKS_WEBHOOK";
    ActionType[ActionType["DUPLICATE_TASK"] = 26] = "DUPLICATE_TASK";
    ActionType[ActionType["USER_WEBHOOK"] = 27] = "USER_WEBHOOK";
})(ActionType || (exports.ActionType = ActionType = {}));
var ActionKey;
(function (ActionKey) {
    ActionKey["UPDATE"] = "updateEntity";
    ActionKey["GENERIC_ACTION"] = "genericAction";
    ActionKey["ALERT"] = "alert";
    ActionKey["SHARED_LOCATION"] = "sharedLocation";
    ActionKey["OPTIMIZATION"] = "optimization";
    ActionKey["CANCEL_TASK"] = "cancelTask";
    ActionKey["CALCULATE_AVAILABILITY_STATE"] = "calculateAvailabilityState";
    ActionKey["NARROW_ACTIONABLE_WP_TIME_WINDOW"] = "narrowActionableWpTimeWindow";
    ActionKey["EMAIL_SHARED_LOCATION"] = "emailSharedLocation";
    ActionKey["TASK_WEBHOOK"] = "taskWebhook";
    ActionKey["TASKS_WEBHOOK"] = "tasksWebhook";
    ActionKey["USER_WEBHOOK"] = "userWebhook";
})(ActionKey || (exports.ActionKey = ActionKey = {}));
//# sourceMappingURL=action.js.map